import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ProcessComponent } from './page/process/process.component';

// firebase
import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { environment } from '../environments/environment';

// toat
import { ToastrModule } from 'ngx-toastr';
import { CommonService } from './service/common.service';
import { SecurityInterceptor } from './interceptors/security.interceptor';
import { LoadingBoxComponent } from './part/loading-box/loading-box.component';
import { AdminComponent } from './page/admin/admin.component';
import { LoginComponent } from './page/login/login.component';
import { DashboardComponent } from './page/dashboard/dashboard/dashboard.component';
import { MenuComponent } from './part/menu/menu.component';

// chart
import { ChartModule } from 'angular2-chartjs';
import { RoomComponent } from './page/dashboard/room/room.component';
import { HomeComponent } from './page/home/home.component';
import { MemberComponent } from './page/dashboard/member/member.component';
import { StationComponent } from './page/dashboard/station/station.component';
import { ReportComponent } from './page/dashboard/room/report/report.component';
import { PowerStorageComponent } from './part/power-storage/power-storage.component';
import { PowerUsageComponent } from './part/power-usage/power-usage.component';
import { ReportplusComponent } from './page/dashboard/room/reportplus/reportplus.component';
import { SettingComponent } from './page/dashboard/setting/setting.component';
import { PowerStorageSettingComponent } from './part/power-storage-setting/power-storage-setting.component';


@NgModule({
  declarations: [
    AppComponent,
    ProcessComponent,
    LoadingBoxComponent,
    AdminComponent,
    LoginComponent,
    DashboardComponent,
    MenuComponent,
    RoomComponent,
    HomeComponent,
    MemberComponent,
    StationComponent,
    ReportComponent,
    PowerStorageComponent,
    PowerUsageComponent,
    ReportplusComponent,
    SettingComponent,
    PowerStorageSettingComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    AngularFirestoreModule,
    AngularFireAuthModule,
    AngularFireModule.initializeApp(environment.firebase),  
    ToastrModule.forRoot({
      timeOut: 4000,
      positionClass: 'toast-bottom-right',
      progressBar: true
    }), // ToastrModule added,
    ChartModule,
  ],
  providers: [
    CommonService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SecurityInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
